import request from '@/utils/request'


// 查询商户行业列表
export function listIndustry(query) {
  return request({
    url: '/biz/admin/merchant/industry/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商户行业分页
export function pageIndustry(query) {
  return request({
    url: '/biz/admin/merchant/industry/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商户行业详细
export function getIndustry(data) {
  return request({
    url: '/biz/admin/merchant/industry/detail',
    method: 'get',
    params: data
  })
}

// 新增商户行业
export function addIndustry(data) {
  return request({
    url: '/biz/admin/merchant/industry/add',
    method: 'post',
    data: data
  })
}

// 修改商户行业
export function updateIndustry(data) {
  return request({
    url: '/biz/admin/merchant/industry/edit',
    method: 'post',
    data: data
  })
}

// 删除商户行业
export function delIndustry(data) {
  return request({
    url: '/biz/admin/merchant/industry/delete',
    method: 'post',
    data: data
  })
}
